import React, { useContext } from 'react';

const UpdaterContext = React.createContext(null);

export default UpdaterContext;

export function useUpdaterContext() {
    return useContext(UpdaterContext);
}
